import Cookies from 'universal-cookie';
import {basename } from "../../constants"
import { Link } from "react-router-dom";

export default function MenuItem({name, linkTo, svgSource}){

    return (
        <div className="favoritePageListItem shadow mb-2">
        <Link to={linkTo} 
                className="block max-w-sm p-6  hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700">
                    {
                        <img className="text-gray-800 dark:text-white" 
                            src={svgSource} 
                            width="70"  alt=""             
                        /> 
                    }


            </Link>
            <Link to={linkTo} 
                className="max-w-sm p-6 m-auto  ">
                    <p className="font-normal text-gray-700 dark:text-gray-400">{name}</p>
            </Link>
            
        </div>
    )
}